
import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

export default function Home() {
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero
        isSubmitted={isFormSubmitted}
        setIsSubmitted={setIsFormSubmitted}
      />
      <Features />
      <HowItWorks />
      <Testimonials />
      <CallToAction />
      <Footer />
    </div>
  );
}
